import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { UserProfileComponent } from '@xpo-ltl/ngx-auth';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { BreadcrumbsComponent } from './shared/components/breadcrumbs/breadcrumbs.component';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { ConfigManagerProperties } from './shared/enums/config-manager-properties.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterModule, XpoShellModule, UserProfileComponent, BreadcrumbsComponent],
})
export class AppComponent {
  readonly title = 'API Store';
  readonly build: string;

  apiStoreRoute = `/${AppRoutes.API_STORE}`;

  constructor(configManagerService: ConfigManagerService) {
    this.build = configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);
  }
}
